import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { ErrorMessage } from "formik";
import Required from "../../../components/Required";
import MaskedInput from 'react-text-mask';
import calendar from '../styles/assets/calendar.png'


const PatientInfomation = ({ formik, inputClasses, props, template, config }) => {
    const [showAlert, setShowAlert] = useState(true);

    const isUser18 = (DOB) => {
        var today = new Date();
        var birthDate = new Date(DOB);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    const setDateLimit = () => {
        let currentDate = new Date();
        currentDate.setFullYear(new Date().getFullYear() - 200);
        return currentDate;
    }



    return (
        config.page.form.sections.patientInformationSection.active ?
            <div id='patientInfoSection' className='form-section'>

                <h2
                    style={template.styles.section}
                    className="section-heading">
                    {template.title}
                </h2>

                <div className="form-fields">


                    {template.fields.patientInfoFirstName.active &&
                        <div className="form-field firstName-field">
                            <label htmlFor="patientInfofirstName">
                                <span style={template.styles.label}>
                                    {template.fields.patientInfoFirstName.label}
                                </span>{" "}
                                <Required
                                    value={
                                        template.fields.patientInfoFirstName.validations.required
                                            .value
                                    }
                                />
                            </label>
                            <input
                                {...formik.getFieldProps("patientInfoFirstName")}
                                maxLength={
                                    template.fields.patientInfoFirstName.validations.maxLength.value
                                }
                                type="text"
                                name="patientInfoFirstName"
                                id="patientInfoFirstName"
                                style={config.page.form.styles.hint}
                                className={inputClasses(
                                    formik.touched.patientInfoFirstName &&
                                    formik.errors.patientInfoFirstName
                                )}
                                placeholder={template.fields.patientInfoFirstName.hint}
                            />
                            <ErrorMessage name="patientInfoFirstName">
                                {msg => <div className="input-error-text">{msg}</div>}
                            </ErrorMessage>

                        </div>
                    }

                    {template.fields.patientInfoMiddleInitial.active && (
                        <div className="form-field MI-field">
                            <label htmlFor="patientInfoMiddleInitial">
                                <span style={template.styles.label}>
                                    {template.fields.patientInfoMiddleInitial.label}
                                </span>{" "}
                                <Required
                                    value={
                                        template.fields.patientInfoMiddleInitial.validations
                                            .required.value
                                    }
                                />
                            </label>
                            <input
                                {...formik.getFieldProps("patientInfoMiddleInitial")}
                                // style={{ width: 65 }}
                                type="text"
                                style={config.page.form.styles.hint}
                                maxLength={
                                    template.fields.patientInfoMiddleInitial.validations
                                        .maxLength.value
                                }
                                name="patientInfoMiddleInitial"
                                id="patientInfoMiddleInitial"
                                className="form-control"
                                placeholder={template.fields.patientInfoMiddleInitial.hint}
                            />
                        </div>
                    )}


                    {template.fields.patientInfoLastName.active &&
                        <div className="form-field lastName-field">
                            <label htmlFor="patientInfoLastName">
                                <span style={template.styles.label}>
                                    {template.fields.patientInfoLastName.label}
                                </span>{" "}
                                <Required
                                    value={
                                        template.fields.patientInfoLastName.validations.required.value
                                    }
                                />
                            </label>
                            <input
                                {...formik.getFieldProps("patientInfoLastName")}
                                type="text"
                                style={config.page.form.styles.hint}
                                maxLength={
                                    template.fields.patientInfoLastName.validations.maxLength.value
                                }
                                name="patientInfoLastName"
                                id="patientInfoLastName"
                                className={inputClasses(
                                    formik.touched.patientInfoLastName &&
                                    formik.errors.patientInfoLastName
                                )}
                                placeholder={template.fields.patientInfoLastName.hint}
                            />
                            <ErrorMessage name="patientInfoLastName">
                                {msg => <div className="input-error-text">{msg}</div>}
                            </ErrorMessage>
                        </div>
                    }

                    {template.fields.patientInfoOtherName.active &&
                        <div className="form-field otherName-field">
                            <label htmlFor="patientInfoOtherName">
                                <span style={template.styles.label}>
                                    {template.fields.patientInfoOtherName.label}
                                </span>{" "}
                                <Required value={template.fields.patientInfoOtherName.required} />
                            </label>
                            <input
                                {...formik.getFieldProps("patientInfoOtherName")}
                                type="text"
                                maxLength="16"
                                name="patientInfoOtherName"
                                id="patientInfoOtherName"
                                style={config.page.form.styles.hint}
                                className={inputClasses(
                                    formik.touched.patientInfoOtherName &&
                                    formik.errors.patientInfoOtherName
                                )}
                                placeholder={template.fields.patientInfoOtherName.hint}
                            />
                            <ErrorMessage name="patientInfoOtherName">
                                {msg => <div className="input-error-text">{msg}</div>}
                            </ErrorMessage>
                        </div>
                    }

                    {template.fields.patientInfoDob.active &&
                        <div className="form-field dob-field">

                            <label htmlFor="patientInfoDob">
                                <span style={template.styles.label}>
                                    {template.fields.patientInfoDob.label}
                                </span>
                                {" "}
                                <Required
                                    value={template.fields.patientInfoDob.validations.required.value}
                                />
                            </label>

                            <div className='date-input'>

                                <input
                                    type='date'
                                    placeholder={template.fields.patientInfoDob.hint}
                                    style={{ paddingTop: 0 }}
                                    id={"patientInfoDob"}
                                    selected={formik.values["patientInfoDob"]}
                                    name={"patientInfoDob"}

                                    onBlur={(e) => {
                                        formik.setFieldTouched("patientInfoDob", true, true)
                                    }}
                                    className={`${inputClasses(
                                        formik.touched.patientInfoDob &&
                                        formik.errors.patientInfoDob
                                    )} date-field`}
                                    onChange={date => {
                                        formik.setFieldTouched("patientInfoDob", true, true)
                                        formik.setFieldValue("patientInfoDob", date.target.value)
                                    }}
                                    onSelect={date => {

                                        formik.setFieldTouched("patientInfoDob", true, true)
                                        formik.setFieldValue("patientInfoDob", date.target.value)
                                    }}
                                />



                            </div>{" "}

                            <ErrorMessage name="patientInfoDob">
                                {msg => <div className="input-error-text">{msg}</div>}
                            </ErrorMessage>
                        </div>
                    }

                    {/* ______________Form Fields below this line have not been formatted______________________ */}

                    <div className="row">

                        {template.fields.patientInfoMrn.active &&
                            <div className="col">
                                <div className="form-group">
                                    <label htmlFor="patientInfoMrn">
                                        <span style={template.styles.label}>
                                            {template.fields.patientInfoMrn.label}
                                        </span>{" "}
                                        <Required
                                            value={
                                                template.fields.patientInfoMrn.validations.required.value
                                            }
                                        />
                                    </label>
                                    <input
                                        {...formik.getFieldProps("patientInfoMrn")}
                                        type="text"
                                        maxLength={
                                            template.fields.patientInfoMrn.validations.maxLength.value
                                        }
                                        name="patientInfoMrn"
                                        id="patientInfoMrn"
                                        className={inputClasses(
                                            formik.touched.patientInfoMrn && formik.errors.patientInfoMrn
                                        )}
                                        placeholder={template.fields.patientInfoMrn.hint}
                                    />
                                    <ErrorMessage name="patientInfoMrn">
                                        {msg => <div className="input-error-text">{msg}</div>}
                                    </ErrorMessage>
                                </div>
                            </div>
                        }
                    </div>


                    <div className="row">
                        {template.fields.patientInfoEmail.active &&
                            <div className="col">
                                <div className="form-group">
                                    <label htmlFor="patientInfoEmail">
                                        <span style={template.styles.label}>
                                            {template.fields.patientInfoEmail.label}
                                        </span>{" "}
                                        <Required
                                            value={
                                                template.fields.patientInfoEmail.validations.required.value
                                            }
                                        />
                                    </label>
                                    <input
                                        {...formik.getFieldProps("patientInfoEmail")}
                                        type="text"
                                        maxLength={
                                            template.fields.patientInfoEmail.validations.maxLength.value
                                        }
                                        name="patientInfoEmail"
                                        id="patientInfoEmail"
                                        className={inputClasses(
                                            formik.touched.patientInfoEmail &&
                                            formik.errors.patientInfoEmail
                                        )}
                                        placeholder={template.fields.patientInfoEmail.hint}
                                    />
                                    {formik.touched.patientInfoEmail &&
                                        formik.errors.patientInfoEmail && (
                                            <span className="input-error-text">
                                                {formik.errors.patientInfoEmail}
                                            </span>
                                        )}
                                </div>
                            </div>
                        }
                        {template.fields.patientInfoEmailConfirmation.active &&
                            <div className="col">
                                <div className="form-group">
                                    <label htmlFor="patientInfoEmailConfirmation">
                                        <span style={template.styles.label}>
                                            {template.fields.patientInfoEmailConfirmation.label}
                                        </span>{" "}
                                        <Required
                                            value={
                                                template.fields.patientInfoEmailConfirmation.validations
                                                    .required.value
                                            }
                                        />
                                    </label>
                                    <input
                                        {...formik.getFieldProps("patientInfoEmailConfirmation")}
                                        type="text"
                                        maxLength={
                                            template.fields.patientInfoEmailConfirmation.validations
                                                .maxLength.value
                                        }
                                        name="patientInfoEmailConfirmation"
                                        id="patientInfoEmailConfirmation"
                                        className={inputClasses(
                                            formik.touched.patientInfoEmailConfirmation &&
                                            formik.errors.patientInfoEmailConfirmation
                                        )}
                                        placeholder={template.fields.patientInfoEmailConfirmation.hint}
                                    />
                                    {formik.touched.patientInfoEmailConfirmation &&
                                        formik.errors.patientInfoEmailConfirmation && (
                                            <span className="input-error-text">
                                                {formik.errors.patientInfoEmailConfirmation}
                                            </span>
                                        )}
                                </div>
                            </div>
                        }
                    </div>


                    <div className="row">
                        {template.fields.patientInfoPhone.active &&
                            <div className="col">
                                <div className="form-group">
                                    <label htmlFor="patientInfoPhone">
                                        <span style={template.styles.label}>
                                            {template.fields.patientInfoPhone.label}
                                        </span>{" "}
                                        <Required
                                            value={
                                                template.fields.patientInfoPhone.validations.required.value
                                            }
                                        />
                                    </label>
                                    <input
                                        {...formik.getFieldProps("patientInfoPhone")}
                                        type="text"
                                        name="patientInfoPhone"
                                        id="patientInfoPhone"
                                        className={inputClasses(
                                            formik.touched.patientInfoPhone &&
                                            formik.errors.patientInfoPhone
                                        )}
                                        placeholder={template.fields.patientInfoPhone.hint}
                                    />
                                    {formik.touched.patientInfoPhone &&
                                        formik.errors.patientInfoPhone && (
                                            <span className="input-error-text">
                                                {formik.errors.patientInfoPhone}
                                            </span>
                                        )}
                                </div>
                            </div>
                        }
                        <div className="col">
                            {template.fields.patientInfoPhoneConfirmation.active &&
                                <div className="form-group">
                                    <label htmlFor="patientInfoPhoneConfirmation">
                                        <span style={template.styles.label}>
                                            {template.fields.patientInfoPhoneConfirmation.label}
                                        </span>{" "}
                                        <Required
                                            value={
                                                template.fields.patientInfoPhoneConfirmation.validations
                                                    .required.value
                                            }
                                        />
                                    </label>
                                    <input
                                        {...formik.getFieldProps("patientInfoPhoneConfirmation")}
                                        type="text"
                                        name="patientInfoPhoneConfirmation"
                                        id="patientInfoPhoneConfirmation"
                                        className={inputClasses(
                                            formik.touched.patientInfoPhoneConfirmation &&
                                            formik.errors.patientInfoPhoneConfirmation
                                        )}
                                        placeholder={template.fields.patientInfoPhoneConfirmation.hint}
                                    />
                                    {formik.touched.patientInfoPhoneConfirmation &&
                                        formik.errors.patientInfoPhoneConfirmation && (
                                            <span className="input-error-text">
                                                {formik.errors.patientInfoPhoneConfirmation}
                                            </span>
                                        )}
                                </div>
                            }
                        </div>
                    </div>


                    <div className="row">
                        {template.fields.patientInfoAddressLine1.active &&
                            <div className="col">
                                <div className="form-group">
                                    <label htmlFor="patientInfoAddressLine1">
                                        <span style={template.styles.label}>
                                            {" "}
                                            {template.fields.patientInfoAddressLine1.label}
                                        </span>{" "}
                                        <Required
                                            value={
                                                template.fields.patientInfoAddressLine1.validations.required
                                                    .value
                                            }
                                        />
                                    </label>
                                    <input
                                        {...formik.getFieldProps("patientInfoAddressLine1")}
                                        type="text"
                                        maxLength={
                                            template.fields.patientInfoAddressLine1.validations.maxLength
                                                .value
                                        }
                                        name="patientInfoAddressLine1"
                                        id="patientInfoAddressLine1"
                                        className={inputClasses(
                                            formik.touched.patientInfoAddressLine1 &&
                                            formik.errors.patientInfoAddressLine1
                                        )}
                                        placeholder={template.fields.patientInfoAddressLine1.hint}
                                    />
                                    {formik.touched.patientInfoAddressLine1 &&
                                        formik.errors.patientInfoAddressLine1 && (
                                            <span className="input-error-text">
                                                {formik.errors.patientInfoAddressLine1}
                                            </span>
                                        )}
                                </div>
                            </div>
                        }
                    </div>


                    <div className="row">
                        {template.fields.patientInfoAddressLine2.active &&
                            <div className="col">
                                <div className="form-group">
                                    {template.fields.patientInfoAddressLine2.label && (
                                        <label htmlFor="patientInfoAddressLine2">
                                            <span style={template.styles.label}>
                                                {template.fields.patientInfoAddressLine2.label}
                                            </span>{" "}
                                            <Required
                                                value={
                                                    template.fields.patientInfoAddressLine2.validations.required
                                                        .value
                                                }
                                            />
                                        </label>
                                    )}
                                    <input
                                        {...formik.getFieldProps("patientInfoAddressLine2")}
                                        type="text"
                                        maxLength={
                                            template.fields.patientInfoAddressLine2.validations.maxLength
                                                .value
                                        }
                                        name="patientInfoAddressLine2"
                                        id="patientInfoAddressLine2"
                                        className={inputClasses(
                                            formik.touched.patientInfoAddressLine2 &&
                                            formik.errors.patientInfoAddressLine2
                                        )}
                                        placeholder={template.fields.patientInfoAddressLine2.hint}
                                    />
                                    {formik.touched.patientInfoAddressLine2 &&
                                        formik.errors.patientInfoAddressLine2 && (
                                            <span className="input-error-text">
                                                {formik.errors.patientInfoAddressLine2}
                                            </span>
                                        )}
                                </div>
                            </div>
                        }
                    </div>


                    <div className="row">
                        {template.fields.patientInfoCity.active &&
                            <div className="col">
                                <div className="form-group">
                                    {template.fields.patientInfoCity.label && (
                                        <label htmlFor="patientInfoCity">
                                            <span style={template.styles.label}>
                                                {template.fields.patientInfoCity.label}
                                            </span>{" "}
                                            <Required
                                                value={
                                                    template.fields.patientInfoCity.validations.required.value
                                                }
                                            />
                                        </label>
                                    )}
                                    <input
                                        {...formik.getFieldProps("patientInfoCity")}
                                        type="text"
                                        maxLength={
                                            template.fields.patientInfoCity.validations.maxLength.value
                                        }
                                        name="patientInfoCity"
                                        id="patientInfoCity"
                                        className={inputClasses(
                                            formik.touched.patientInfoCity && formik.errors.patientInfoCity
                                        )}
                                        placeholder={template.fields.patientInfoCity.hint}
                                    />
                                    {formik.touched.patientInfoCity &&
                                        formik.errors.patientInfoCity && (
                                            <span className="input-error-text">
                                                {formik.errors.patientInfoCity}
                                            </span>
                                        )}
                                </div>
                            </div>
                        }
                        {template.fields.patientInfoState.active &&
                            <div className="col-sm-3">
                                <div className="form-group">
                                    {template.fields.patientInfoState.label && (
                                        <label htmlFor="patientInfoState">
                                            <span style={template.styles.label}>
                                                {template.fields.patientInfoState.label}
                                            </span>{" "}
                                            <Required
                                                value={
                                                    template.fields.patientInfoState.validations.required.value
                                                }
                                            />
                                        </label>
                                    )}
                                    <input
                                        {...formik.getFieldProps("patientInfoState")}
                                        type="text"
                                        maxLength={
                                            template.fields.patientInfoState.validations.maxLength.value
                                        }
                                        name="patientInfoState"
                                        id="patientInfoState"
                                        className={inputClasses(
                                            formik.touched.patientInfoState &&
                                            formik.errors.patientInfoState
                                        )}
                                        placeholder={template.fields.patientInfoState.hint}
                                    />
                                    {formik.touched.patientInfoState &&
                                        formik.errors.patientInfoState && (
                                            <span className="input-error-text">
                                                {formik.errors.patientInfoState}
                                            </span>
                                        )}
                                </div>
                            </div>
                        }
                        {template.fields.patientInfoZip.active &&
                            <div className="col-sm-2">
                                <div className="form-group">
                                    {template.fields.patientInfoZip.label && (
                                        <label htmlFor="patientInfoZip">
                                            <span style={template.styles.label}>
                                                {template.fields.patientInfoZip.label}
                                            </span>{" "}
                                            <Required
                                                value={
                                                    template.fields.patientInfoZip.validations.required.value
                                                }
                                            />
                                        </label>
                                    )}
                                    <input
                                        {...formik.getFieldProps("patientInfoZip")}
                                        type="text"
                                        name="patientInfoZip"
                                        id="patientInfoZip"
                                        className={inputClasses(
                                            formik.touched.patientInfoZip && formik.errors.patientInfoZip
                                        )}
                                        placeholder={template.fields.patientInfoZip.hint}
                                    />
                                    {formik.touched.patientInfoZip && formik.errors.patientInfoZip && (
                                        <span className="input-error-text">
                                            {formik.errors.patientInfoZip}
                                        </span>
                                    )}
                                </div>
                            </div>
                        }
                    </div></div>
            </div>
            :
            <></>
    );
};

export default PatientInfomation;
